/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M14.2 3.3l-1.4 1.4L23.1 15H4v2h19.1L12.8 27.3l1.4 1.4L26.9 16z"/>'
  }
})
